import React from 'react';
import { ComponentTypes } from 'logi-embed/types';
import { LogiComponent } from '../LogiComponent';
/**
 * LogiSourceEditor component.
 * Used to edit logi sources or create new ones
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.configuration - The configuration object.
 * @param {Function} props.getToken - The function to get the token.
 * @param {string} props.logiBaseUrl - The base URL for Logi Composer.
 * @param {string} props.sourceEditorStyleWidth - The width style for the visual builder.
 * @param {string} props.sourceEditorStyleHeight - The height style for the visual builder.
 * @example
 * ```tsx
 * <LogiSourceEditor
 *   configuration={configuration}
 *   getToken={getToken}
 *   logiBaseUrl={logiBaseUrl}
 *   sourceEditorStyleWidth={sourceEditorStyleWidth}
 *   sourceEditorStyleHeight={sourceEditorStyleHeight}
 * />
 * ```
 */
export const LogiSourceEditor = ({ configuration, getToken, logiBaseUrl, sourceEditorStyleWidth, sourceEditorStyleHeight, }) => {
    return (React.createElement(LogiComponent, { componentType: ComponentTypes.SOURCE_EDITOR, configuration: configuration, getToken: getToken, logiBaseUrl: logiBaseUrl, styleWidth: sourceEditorStyleWidth, styleHeight: sourceEditorStyleHeight, ariaLabel: 'Logi Source Editor' }));
};
